import React from 'react';
import PropTypes from 'prop-types';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import { Grid, Form, Button, Divider } from 'semantic-ui-react';
import moment from 'moment';

import { Column } from 'components/Layout';
import AnagraficaService from 'shared/services/api/anagrafica';

import { DatePicker } from '../../UI/DatePicker';
import DividerForm from '../../UI/DividerForm';
import { SuggestComuneString, SuggestIndirizzo } from '../../UI/GeoSuggest';
import { Input } from '../../UI/Input';

export class ResponsabileAreaForm extends React.Component {

  state = {
    loadingPiva: false,
  };

  getPIVA = (props) => {
    this.setState({ loadingPiva: true },
    () => AnagraficaService.getPIVA(props.values.anagrafica)
    .then((res) => {
      props.setFieldValue('partitaiva', res);
      this.setState({ loadingPiva: false });
    })
  );
  };

  render() {
    return (
      <Form autoComplete="off" onSubmit={this.props.handleSubmit} loading={this.props.isSubmitting}>
        <Grid>
          <Column width={16}>
            <Divider horizontal>Dati professionali</Divider>
          </Column>
          <Column width={8}>
            <Input label="Ragione Sociale" {...this.props} name="ragioneSociale" />
          </Column>
          <Column width={8}>
            <Input
              label="Partita IVA"
              {...this.props}
              name="partitaiva"
              style={{ position: 'relative' }}
              btn={{ loading: this.state.loadingPiva, action: () => this.getPIVA(this.props), icon: 'copy', tooltip: 'Copia da anagrafica' }}
            />
          </Column>
          <Column width={16}>
            <SuggestIndirizzo
              initialValue={this.props.values.indirizzoCompleto}
              onChange={this.props.setFieldValue}
              onBlur={this.props.setFieldTouched}
              error={this.props.errors.indirizzoCompleto}
              touched={this.props.touched.indirizzoCompleto}
              flat
              label="Sede legale"
              name="sedelegale"
            />
          </Column>
          <Column width={16}>
            <Divider horizontal>Dati REA</Divider>
          </Column>
          <Column width={6}>
            <SuggestComuneString
              initialValue={this.props.values.registroImprese}
              onChange={this.props.setFieldValue}
              onBlur={this.props.setFieldTouched}
              error={this.props.errors.registroImprese}
              touched={this.props.touched.registroImprese}
              name="registroImprese"
              label="Registro imprese"
            />
          </Column>
          <Column width={5}>
            <Input label="REA" {...this.props} name="rea" />
          </Column>
          <Column width={5}>
            <Input label="Codice attività" {...this.props} name="codiceAttivita" />
          </Column>
          <Column width={16}>
            <Divider horizontal>Dati Contrattuali</Divider>
          </Column>
          <Column width={6}>
            <Input label="Numero contratto" {...this.props} name="contratto_numero" />
          </Column>
          <Column width={5}>
            <DatePicker {...this.props} value={this.props.values.contratto_dataDecorrenza} onChange={this.props.setFieldValue} name="contratto_dataDecorrenza" label="Data decorrenza" startDate={moment()} openDirection="up" />
          </Column>
          <Column width={5}>
            <DatePicker {...this.props} value={this.props.values.contratto_dataRescissione} onChange={this.props.setFieldValue} name="contratto_dataRescissione" label="Data rescissione" startDate={moment()} openDirection="up" />
          </Column>
          <DividerForm />
          <Column width={8}>
            <Button onClick={this.props.closeModal} type="button" icon="delete" labelPosition="right" content="Chiudi" />
          </Column>
          <Column width={8} textAlign="right">
            <Button loading={this.props.isSubmitting} type="submit" icon="save" labelPosition="left" positive disabled={this.props.isSubmitting} content="Salva" />
          </Column>
        </Grid>
      </Form>);
  }

}

export default ResponsabileAreaForm;

ResponsabileAreaForm.propTypes = {
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  setFieldTouched: PropTypes.func,
  handleSubmit: PropTypes.func,
  closeModal: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/ResponsabileArea/Form.js